<template>
    <div id="image-cropper">
      <div>
        <cropper 
          ref="cropper" 
          :src="src" 
          class="cropper-img"
          backgroundClass="bg-transparent"
          :image-restriction="styleRestriction"
          :min-height="minHeight"
          :min-width="minWidth"
          :stencil-component="stencil"
          :stencil-props="{ aspectRatio: styleRatio }"
        />
      </div>

      <div class="w-full flex justify-center items-center" style="flex-direction: column;">
          <vs-button class="mt-6" @click="cropImage" :disabled="submitData">
            {{ !submitData ? 'Salvar' : 'Enviando'}}
          </vs-button>
        </div>
    </div>
  </template>
  
  <script>
  
  import { Cropper } from "vue-advanced-cropper";
  import "vue-advanced-cropper/dist/style.css";
  import axios from 'axios'
  
  export default {
    name: "ImageCropper",
    props: {
      src: {
        default: null,
        required: true
      },
      minWidth:{
        default: '50',
        type: String,
        required: false
      },
      minHeight:{
        default: '50',
        type: String,
        required: false
      },
      styleRestriction:{
        default: 'none',
        type: String,
        required: false
      },
      styleRatio: {
        default: '1',
        type: String,
        required: false
      },
      stencil: {
        default: 'rectangle-stencil',
        type: String,
        required: false
      }
    },
    components: {
      Cropper
    },
    data() {
      return {
        submitData: false
      }
    },
    watch: {
      submitData(val) {
        if (val) {
          setTimeout(() => {
            this.submitData = false;
          }, 10000);
        }
      }
    },
    computed:{
      uploadApiUrl() {
        return localStorage.getItem("baseUrl") + "/api/file/upload";
      },
      bearer() {
        return this.$store.state.auth.bearer;
      },
    },
    methods: {
      cropImage() {
          this.submitData = true;
          const { canvas } = this.$refs.cropper.getResult();

          if (canvas) {
            var formData = new FormData();
            canvas.toBlob(blob => {
              const myFile = new File([blob], "image.png");
              formData.append('file', myFile);

              try{
                  axios.post(this.uploadApiUrl, formData, {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                      'Authorization': 'Bearer ' + this.bearer
                    }
                  }).then(response => {
                    this.$emit('on-cropp-image', response)
                  });
              } catch(error) {
                console.error(error);
                this.$vs.notify({
                  color: 'warning',
                  title: "Recortagem da Imagem",
                  text: 'Ocorreu um problema ao recordar a imagem.',
                })
              }
            }, 'image/png');
        }
      }
    },
    created() {}
  }
  </script>
  
  <style lang="scss">
    #image-cropper{
      .switch{
        border: 1px solid rgba(0, 0, 0, 0.2); 
        border-radius: 10px;
      }
    }
  
    .cropper-img {
      width: 100%;
      height: 85vh;
      max-height: 300px;
    }
  </style>
  